import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

  {
    id: 0,
    label: 'MENUITEMS.BUSSINESS_ACCOUNTS.TEXT',
    icon: 'ri-user-settings-line',
    link: '/business-accounts/list',
  },
  {
    id: 1,
    label: 'MENUITEMS.CONNECTIVITY_STATUS.TEXT',
    icon: 'ri-refresh-line',
    link: '/connectivity-status',
  },
  // {
  //   id: 2,
  //   label: 'MENUITEMS.DASHBOARD.TEXT',
  //   icon: 'ri-dashboard-line',
  //   link: '/',
  // },

  // {
  //   id: 2,
  //   label: 'MENUITEMS.OPEN_BANKING.TEXT',
  //   icon: 'ri-bank-fill',
  //   link: '/open-banking',
  //   subItems: [
  //     {
  //       id: 6,
  //       label: 'MENUITEMS.E_STATEMENT.TEXT',
  //       icon: 'ri-currency-line',
  //       link: '/open-banking',
  //     },
  //     {
  //       id: 7,
  //       label: 'MENUITEMS.LETTER_OF_GUARANTEE.TEXT',
  //       icon: 'ri-file-list-line',
  //       link: '/open-banking/letter-guarantee',
  //       badge: {
  //         variant: 'bg-phosphoric text-black',
  //         text: 'COMMON.SOON',
  //       },
  //       disabled: true,
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   label: 'MENUITEMS.CASH_ANALYSIS.TEXT',
  //   icon: 'ri-bar-chart-grouped-fill',
  //   link: '/cash-analysis',
  // },
  // {
  //   id: 3,
  //   label: 'MENUITEMS.TRANSACTIONS.TEXT',
  //   icon: 'ri-grid-line',
  //   link: '/transactions',
  // },
  // {
  //   id: 5,
  //   label: 'MENUITEMS.PAYMENTS.TEXT',
  //   icon: 'bx bx-credit-card',
  //   link: '/payments',
  //   subItems: [
  //     {
  //       id: 6,
  //       label: 'MENUITEMS.BENEFICIARY.TEXT',
  //       icon: 'mdi mdi-account-group-outline',
  //       link: '/beneficiary',
  //     },
  //     {
  //       id: 7,
  //       label: 'MENUITEMS.PAYMENT_WORKFLOW.TEXT',
  //       icon: 'mdi mdi-sitemap-outline',
  //       link: '/payments/payment-workflow',
  //     },
  //   ],
  //   badge: {
  //     variant: 'bg-phosphoric text-black',
  //     text: 'COMMON.SOON',
  //   },
  //   disabled: true
  // },
  // {
  //   id: 8,
  //   label: 'MENUITEMS.FORECASTING.TEXT',
  //   icon: 'ri-line-chart-line',
  //   link: '/forecasting',
  // },
  // {
  //   id: 9,
  //   label: 'MENUITEMS.RECONCILIATION.TEXT',
  //   icon: 'ri-donut-chart-line',
  //   link: '/reconciliation/statistics',
  //   badge: {
  //     variant: 'bg-phosphoric text-black',
  //     text: 'COMMON.SOON',
  //   },
  //   disabled: true
  // },

  // {
  //   id: 10,
  //   label: 'MENUITEMS.CASH_POSITIONING.TEXT',
  //   icon: 'ri-exchange-funds-line',
  //   link: '/cash-reporting',
  //   badge: {
  //     variant: 'bg-phosphoric text-black',
  //     text: 'COMMON.SOON',
  //   },
  //   disabled: true
  // },
  // {
  //   id: 11,
  //   label: 'MENUITEMS.IMPORT.TEXT',
  //   icon: 'ri-download-2-line',
  //   link: '/import-management',
  // },
  // {
  //   id: 12,
  //   label: 'MENUITEMS.IMPORT.TEXT',
  //   icon: 'ri-download-2-line',
  //   link: '/import',
  // },
  // {
  //   id: 13,
  //   label: 'MENUITEMS.SETTING.TEXT',
  //   icon: 'ri-settings-5-line',
  //   link: '/setting',
  // },
  // {
  //   id: 14,
  //   label: 'MENUITEMS.DEVELOPER.TEXT',
  //   icon: 'ri-code-fill',
  //   link: '/developer',
  // },
];